import { Component, OnInit, OnDestroy, ViewChild, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { ManageService } from '../../../../services/manage.service';
import { Subject } from 'rxjs';
import { CSPPerpetualItemsViewModel, CSPPerpetualModifyViewModel, CSPCustomerEntitlementsViewModel, GetCSPSubscription, CSPModifySubscriptionViewModel, CSPModifySubscriptionResponse, CSPSubscriptions, SupportedBillingCycle } from '../../../../models/csp.model';
import { AnnuityItemsViewModel } from '../../../../models/annuity-view.model';
import { MatDialog } from '@angular/material/dialog';
import { FinishSoftwareComponent } from '../../../../popup-collection/finish-software/finish-software.component';
import { ConfirmSoftwareComponent } from '../../../../popup-collection/confirm-software/confirm-software.component';
import { ADKDetailsViewModel } from '../../../../models/adk-details-view.model';
import { PerpetualApiResponse, SubscriptionApiResponse, MnpIdAipiResponse } from '../../../../models/api-response.model';
import { CommonService } from '../../../../services';
import { ConfirmAzureRiComponent } from '../../../../popup-collection/confirm-azure-ri/confirm-azure-ri.component';
import { FinishAzureRiComponent } from '../../../../popup-collection/finish-azure-ri/finish-azure-ri.component';
import { ConfirmSubscriptionComponent } from '../../../../popup-collection/confirm-subscription/confirm-subscription.component';
import { FinishSubscriptionComponent } from '../../../../popup-collection/finish-subscription/finish-subscription.component';
import { debounceTime, skip, takeUntil } from 'rxjs/operators';
import { FormArray, FormControl } from '@angular/forms';
import { ConfirmMnpidComponent } from '../../../../popup-collection/confirm-mnpid/confirm-mnpid.component';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { PanelService } from '../../../../services/panel.service';
import { AuthService } from '../../../../services/auth.service';
import { CurrentUserModel } from '../../../../models/account-ledger.model';
import { NgProgressService } from '../../../../services/ngProgress.service';
import { FileService } from '../../../../services/file.service';

@Component({
  selector: 'app-confirm-products-v2',
  templateUrl: './confirm-product-v2.component.html',
  styleUrls: ['./confirm-product-v2.component.css'],
  providers: [DatePipe, CurrencyPipe]
})

export class ConfirmProductsV2Component implements OnInit, OnDestroy {
  @ViewChild("ParentWrapper") parentWrapper: ElementRef;
  @ViewChild("customEndAateInput") customEndAateInput: ElementRef;
  //ngunsubscribe
  title: string = 'Confirm Products';
  loadContent: boolean = false;
  tenantId: string;
  productType: string;
  purchase: string;
  details: ADKDetailsViewModel;
  checkMpnId: Boolean = false;
  checkBillingFrequency: Boolean = false;
  mpnList: string[];
  SupportedBillingCycleTypes: Array<string> = [];
  supportedBillingCycleTypesList: SupportedBillingCycle[] = [];
  skuList: Array<string> = [];
  billingFrequencyList: SupportedBillingCycle[];
  showMpnIdloading: boolean;
  azureRiMPNControl: FormControl;
  // public customEndDateTypeControl = new FormControl('Default');
  public customEndDateTypeList = [
    'Default',
    'Co-Term',
    'Align Calendar Month'
  ];
  // customEndDate: FormControl;
  private setSideNavIndex: number;
  public customEndDateTypeFormArray = new FormArray([]);
  public customEndDatesFormArray = new FormArray([]);

  ngUnsubscribe: Subject<void> = new Subject<void>();

  //pending list
  azureRIItemsPendingList: CSPPerpetualItemsViewModel[] = [];
  softwareSubscriptionPendingList: CSPPerpetualItemsViewModel[] = [];
  subscriptionItemsPendingList: AnnuityItemsViewModel[] = [];
  azureSubscriptionItemsPendingList: AnnuityItemsViewModel[] = [];
  subscriptionItems: AnnuityItemsViewModel[] = [];

  combineSubscriptionItemsPendingList: AnnuityItemsViewModel[] = [];

  //software
  totalSoftwareSubscriptionPendingPrice = 0;
  continueSaveSoftwareSubscriptionItem: CSPPerpetualModifyViewModel;
  continueSaveSoftwareSubscriptionList: CSPPerpetualModifyViewModel[] = [];
  softwareSubscriptionApiResponse: PerpetualApiResponse;
  softwareMPNControl: FormControl;
  softwareMpnIdSelect: string;
  checkSoftwareMpnId: boolean = true;
  isCheck: Boolean;
  isBillingFreq: boolean = true;
  supportedBillingCycleTypesListForSoftware: SupportedBillingCycle[] = [];
  billingFrequencyListForSoftware: SupportedBillingCycle[];

  //Azure RI
  azureRiMpnIdSelect: string;
  checkAzureRiMpnId: boolean = true;
  isAzureRiCheck: Boolean;
  totalAzureRiPendingPrice = 0;
  continueSaveAzureRiItem: CSPPerpetualModifyViewModel;
  continueSaveAzureRiList: CSPPerpetualModifyViewModel[] = [];
  azureRiApiResponse: PerpetualApiResponse;

  //Azure Subscription
  showEmailloading: Boolean;
  isToCheckOwnerEmail: Boolean = false;
  checkEmail: Boolean = true;



  //Subscription
  // pendingRowConfirmStatus = false;
  originalBaseQty: string[];
  originalAddonQty: any[];
  originalBaseActive: boolean[];
  originalAddonActive: any[];
  totalPriceChange = 0;
  pendingTotal = 0;
  activeTotal = '0';
  // changeSubscriptionAmount: number;
  confirmAnnuityItemSubscription: CSPModifySubscriptionViewModel;
  confirmSubscriptions: CSPModifySubscriptionViewModel[];
  finishSubscriptions: CSPModifySubscriptionResponse[];
  poReference = '';
  NoMPNText = '';

  isConfirmingSoftwareMpnID: boolean = false;
  isConfirmingAzureRiMpnID: boolean = false;

  public subsForViewEndDates: CSPSubscriptions[]

  public isStaffAccount = false;
  public currentUserModel: CurrentUserModel;
  accountId : string;

  currentLineItemsId: number;


  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private manageService: ManageService,
    public commonService: CommonService,
    public calendar: NgbCalendar,
    private datePipe: DatePipe,
    public sidenavService: PanelService,
    private vcr: ViewContainerRef,
    private ngProgress: NgProgressService,
    private authService: AuthService,
    private fileService: FileService,
    private currencyPipe: CurrencyPipe
  ) {
    this.softwareMPNControl = new FormControl();
    this.azureRiMPNControl = new FormControl();
    // this.customEndDate = new FormControl();
    this.NoMPNText = commonService.NoMPNText;
  }

  ngOnInit() {
    this.loadContent = true;

    this.checkMpnId = true;

    this.checkBillingFrequency = true;

    this.isBillingFreq = true;

    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 500 + $('#addProduct').width() + $('#addProductSideBar').width() }, 400);

    // this.changeSubscriptionAmount = toNumber(this.commonService.readCookie('ChangeSubscriptionAmount'));

    this.activatedRoute.parent.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => this.tenantId = params.get('tenantId'));

    this.activatedRoute.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => {
      this.productType = params.get('productType');
    });


    this.manageService.currentCSPPurchase.pipe(takeUntil(this.ngUnsubscribe)).subscribe(purchase => this.purchase = purchase);

    this.manageService.currentMPNList.pipe(takeUntil(this.ngUnsubscribe)).subscribe(list => this.mpnList = list);

    this.manageService.currentDetailsWatch.pipe(takeUntil(this.ngUnsubscribe)).subscribe(details => this.details = details);

    //load pending list
    this.manageService.currentPendingAzureRi.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CSPPerpetualItemsViewModel[]) => {
      this.azureRIItemsPendingList = res;
      this.commonService.applyScrollFixedHeader(this.parentWrapper);
    },
      (error: any) => {
        console.info(error);
      });

    // this.manageService.currentPendingSoftware.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CSPPerpetualItemsViewModel[]) => {
    //   this.softwareSubscriptionPendingList = res;
    //   this.commonService.applyScrollFixedHeader(this.parentWrapper);
    // },
    //   (error: any) => {
    //     console.info(error);
    //   }); 

    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (user: CurrentUserModel) => {
          this.currentUserModel = user;
          this.isStaffAccount = user.isStaffAccount;
          this.accountId = user.accountId;
        }
      );


    this.manageService.getCurrentCSPProductList.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      value => {
        this.subscriptionItems = value;
        this.getPendingSoftware();
        this.getPendingSubscription();
      }
    );


    this.manageService.currentSoftwareMPN.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      value => {
        this.softwareMpnIdSelect = value.mpn;
        this.checkSoftwareMpnId = value.check;
      }
    );

    this.manageService.currentAzureRiMPN.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      value => {
        this.azureRiMpnIdSelect = value.mpn;
        this.checkAzureRiMpnId = value.check;
      }
    );

    this.softwareMPNControl.valueChanges.pipe(
      skip(1),
      debounceTime(1000),
      takeUntil(this.ngUnsubscribe)
    ).subscribe(mpn => {
      this.confirmSoftwareMpnID(mpn);
    });

    this.azureRiMPNControl.valueChanges.pipe(
      skip(1),
      debounceTime(1000),
      takeUntil(this.ngUnsubscribe)
    ).subscribe(mpn => {
      this.confirmAzureRiMpnID(mpn);
    });

    this.manageService.currentExistingCSPSubscriptions.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      value => {
        this.subsForViewEndDates = value?.filter(s => s.baseSubscription.out_charge_type === 'NCE' && (new Date(s.baseSubscription.out_expiry_date) > new Date()));
        if (this.subsForViewEndDates?.length <= 0) {
          const index = this.customEndDateTypeList.indexOf('Co-Term');
          if (index !== -1) {
            this.customEndDateTypeList.splice(index, 1);
          }
        }
      }
    );
  }

  changeEndDateType(value, tempRef, sku, index) {
    let dateToChange = {}
    if (value == 'Align Calendar Month') {
      let term = sku.split(':')[0];
      if (term.includes('Y')) {
        let expDate = new Date();
        expDate.setMonth(expDate.getMonth() + 11);
        let year = expDate.getFullYear();
        let month = expDate.getMonth() + 1;
        let day = new Date(year, month, 0).getDate();
        dateToChange = { year, month, day }
      }
      else {

        const today = new Date();
        const year = today.getFullYear();
        const today_day = today.getDate();
        const month = today.getMonth() + 1;
        if (today_day < 28 || month == 2) { // end date alignment can't be after 27th else if should be FEB

          let day = new Date(year, month, 0).getDate();
          dateToChange = {
            year, month, day
          }
        }
      }
    } else if (value == 'Co-Term') {
      this.openRightPanel(tempRef, index)
    } else {
      if (this.sidenavService?.panel?.opened) {
        this.sidenavService.panel.close()
      }
    }
    this.getCustomEndDateControlByIndex(index).setValue(dateToChange)
    // this.customEndDate.setValue(dateToChange);
  }

  confirmSoftwareMpnID(mpnId: string): void {

    if (mpnId === '' || mpnId === null || mpnId == this.NoMPNText) {
      this.checkSoftwareMpnId = true;
      this.manageService.monitorSoftwareMPN({ mpn: mpnId, check: this.checkSoftwareMpnId });
    } else {
      this.commonService.implementToast('Verifying MPN ID ...', 'Info');
      this.isCheck = true;
      this.isConfirmingSoftwareMpnID = true;
      this.manageService.GetPartnerByMPNId(mpnId).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: MnpIdAipiResponse) => {
        if (res.result === 'Success') {
          this.manageService.GetMPAStatusByMPNId(mpnId).pipe(takeUntil(this.ngUnsubscribe)).subscribe((result: MnpIdAipiResponse) => {
            if (result.status === false) {
              this.checkSoftwareMpnId = result.status;
              this.commonService.implementToast('Verifying Microsoft Partner Agreement Status ...', 'Info');
              const dialogRef = this.dialog.open(ConfirmMnpidComponent, {
                width: '650px',
              });
              this.isCheck = false;
            } else {
              this.checkSoftwareMpnId = result.status;
              this.isCheck = false;
            }
            this.isConfirmingSoftwareMpnID = false;
            this.manageService.monitorSoftwareMPN({ mpn: mpnId, check: this.checkSoftwareMpnId });

          });
        } else {
          this.commonService.implementToast(res.info, 'Error');
          this.isCheck = false;
          this.checkSoftwareMpnId = false;
          this.isConfirmingSoftwareMpnID = false;
          this.manageService.monitorSoftwareMPN({ mpn: mpnId, check: this.checkSoftwareMpnId });
        }
      },
        (error: any) => {
          console.info(error);
          this.isConfirmingSoftwareMpnID = false;
          this.loadContent = true;
        }
      );
    }
  }

  confirmAzureRiMpnID(mpnId: string): void {
    if (mpnId === '' || mpnId === null) {
      this.checkAzureRiMpnId = true;
      this.manageService.monitorAzureRiMPN({ mpn: mpnId, check: this.checkAzureRiMpnId });
    } else {
      this.commonService.implementToast('Verifying MPN ID ...', 'Info');
      this.isAzureRiCheck = true;
      this.isConfirmingAzureRiMpnID = true;
      this.manageService.GetPartnerByMPNId(mpnId).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: MnpIdAipiResponse) => {
        if (res.result === 'Success') {
          this.manageService.GetMPAStatusByMPNId(mpnId).pipe(takeUntil(this.ngUnsubscribe)).subscribe((result: MnpIdAipiResponse) => {
            if (result.status === false) {
              this.checkAzureRiMpnId = result.status;
              this.commonService.implementToast('Verifying Microsoft Partner Agreement Status ...', 'Info');
              const dialogRef = this.dialog.open(ConfirmMnpidComponent, {
                width: '650px',
              });
              this.isAzureRiCheck = false;
            } else {
              this.checkAzureRiMpnId = result.status;
              this.isAzureRiCheck = false;
            }
            this.isConfirmingAzureRiMpnID = false;
            this.manageService.monitorAzureRiMPN({ mpn: mpnId, check: this.checkAzureRiMpnId });
          });
        } else {
          this.commonService.implementToast(res.info, 'Error');
          this.isAzureRiCheck = false;
          this.checkAzureRiMpnId = false;
          this.isConfirmingAzureRiMpnID = false;
          this.manageService.monitorAzureRiMPN({ mpn: mpnId, check: this.checkAzureRiMpnId });
        }
      },
        (error: any) => {
          console.info(error);
          this.isConfirmingAzureRiMpnID = false;
          this.loadContent = true;
        }
      );
    }
  }

  toggleBillingFreq(sub: AnnuityItemsViewModel) {
    // if (sub.defaultBillingFreq == 'Annual') {
    //   sub.editBillingFrequency = !sub.editBillingFrequency;
    // }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
    this.router.navigate(['../'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute })
  }

  //azure RI
  removeAzureRIItemsPending(index: number): void {
    this.azureRIItemsPendingList.splice(index, 1);
    this.manageService.monitorPendingAzureRi(this.azureRIItemsPendingList);
  }

  confirmAzureRiList(): void {
    //prevent confirming when checking MPN
    if (this.isConfirmingAzureRiMpnID) {
      return;
    }

    //check mpnId is not empty for all pendingSubscritions
    if (!this.azureRiMpnIdSelect) {
      this.commonService.implementToast('MPN is mandatory', 'Error');
      return;
    }

    this.totalAzureRiPendingPrice = 0;

    this.azureRIItemsPendingList.forEach(item => {
      if (item.isMonthly) {
        item.totalPrice = this.commonService.toNumber(item.monthlyPrice.replace('$', '').replace(',', '')) * this.commonService.toNumber(item.quantity);
        this.totalAzureRiPendingPrice += this.commonService.toNumber(item.monthlyPrice.replace('$', '').replace(',', '')) * this.commonService.toNumber(item.quantity);
      } else {
        item.totalPrice = this.commonService.toNumber(item.itemPrice.replace('$', '').replace(',', '')) * this.commonService.toNumber(item.quantity);
        this.totalAzureRiPendingPrice += this.commonService.toNumber(item.itemPrice.replace('$', '').replace(',', '')) * this.commonService.toNumber(item.quantity);
      }

    });

    const dialogRef = this.dialog.open(ConfirmAzureRiComponent, {
      width: '650px',
      data: { totalAzureRiPendingPrice: this.totalAzureRiPendingPrice }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.continueSaveAzureRiList = [];
        this.loadContent = false;
        if (this.azureRIItemsPendingList.length) {
          this.azureRIItemsPendingList.forEach(item => {
            this.continueSaveAzureRiItem = {} as CSPPerpetualModifyViewModel;
            this.continueSaveAzureRiItem = {
              tenantId: this.tenantId,
              tenantName: this.details.customer.out_company_name,
              lineType: item.lineType,
              customerReference: result,
              unitPrice: item.itemPrice,
              lineTotal: item.totalPrice.toString(),
              stockCode: item.stockCode,
              description: item.description,
              skuId: item.skuId,
              billingFrequency: item.billingFrequency,
              productId: item.productId,
              catalogItemId: item.catalogItemId,
              qty: item.quantity,
              status: 'PS',
              // mpnId: item.mpnId,
              mpnId: this.commonService.parseNPM(this.azureRiMpnIdSelect),
              lineSeq: '',
              isUpdateSuccessful: true,
              isMonthly: item.isMonthly,
              orderNumber: '',
              message: '',
              subscriptionId: item.subscriptionId,
              scope: item.scope
            };
            this.continueSaveAzureRiList.push(this.continueSaveAzureRiItem);
          });


          this.manageService.CreatePerpetualOrder(this.continueSaveAzureRiList).subscribe((res: PerpetualApiResponse) => {
            this.azureRiApiResponse = res;
            this.loadContent = true;
            // tslint:disable-next-line:no-shadowed-variable
            const dialogRef = this.dialog.open(FinishAzureRiComponent, {
              width: '650px',
              data: { azureRiApiResponse: this.azureRiApiResponse }
            });

            dialogRef.afterClosed().subscribe(() => {
              this.azureRIItemsPendingList = [];
              // this.loadContent = false;
              this.manageService.monitorPendingAzureRi([]);
              this.manageService.monitorAzureRIConfirmValue('Update');
            });
          },
            (error: any) => {
              const azureRiApiResponse = {
                status: 'Fail',
                message: error.message
              };
              this.loadContent = true;
              // tslint:disable-next-line:no-shadowed-variable
              const dialogRef = this.dialog.open(FinishAzureRiComponent, {
                width: '650px',
                data: { azureRiApiResponse: azureRiApiResponse }
              });

              dialogRef.afterClosed().subscribe(() => {
                this.azureRIItemsPendingList = [];
                // this.loadCSPAzureri = false;
                this.manageService.monitorPendingAzureRi([]);
              });
              console.error(error);
            });
        }
      }
    });

  }

  ValidateEmail(mail: string): boolean {
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(mail)) {
      return true
    }
    else {
      return false
    }
  }

  //azure plan subscription
  checkSubscriptionOwnerEmailStatus(annuityItemPending: AnnuityItemsViewModel) {
    this.showEmailloading = true;
    this.isToCheckOwnerEmail = true;
    this.checkEmail = false;
    if (this.ValidateEmail(annuityItemPending.ownerEmail)) {
      this.commonService.implementToast('Verifying owner email within tenant domain....', 'Info');
      this.manageService.CheckSubscriptionOwnerEmailStatus(annuityItemPending.ownerEmail, this.tenantId).subscribe((res: SubscriptionApiResponse) => {

        annuityItemPending.ownerEmailStatus = true;
        this.showEmailloading = false;
        this.checkEmail = true;
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    } else {
      annuityItemPending.ownerEmailStatus = false;
      this.commonService.implementToast('Please provide subscription owner email address', 'Info');
      this.showEmailloading = false;
      this.checkEmail = false;
    }
  }
  //software
  getPendingSoftware(): void {
    this.manageService.currentPendingSoftware.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CSPPerpetualItemsViewModel[]) => {
      const isRemove = this.softwareSubscriptionPendingList.length > res.length;
      const hasSOFT = res.find(x => x.lineType == "SOFT");
      const skuListForSoftware: Array<string> = [];

      this.softwareSubscriptionPendingList = res.map((sub) => {
        if (sub.lineType == 'SOFT') {
          sub.billingFrequency = '';
          skuListForSoftware.push(sub.stockCode);
        } 
        return sub;
      })

      if (res?.length && hasSOFT && !isRemove) {
        this.manageService.GetSupportedBillingCycleType(this.tenantId, skuListForSoftware).pipe(takeUntil(this.ngUnsubscribe)).
          subscribe((billingFrequencyList: SupportedBillingCycle[]) => {
            this.isBillingFreq = true;
            this.supportedBillingCycleTypesListForSoftware = billingFrequencyList;

            if (billingFrequencyList.length) {
              this.softwareSubscriptionPendingList.map((item) => {
                if (item.lineType == 'SOFT') {
                  if (billingFrequencyList.filter(x => x.stockCode == item.stockCode).length) {
                    item.supportedBillingCycleTypes = billingFrequencyList.filter(x => x.stockCode == item.stockCode)[0].supportedBillingCycleTypes;
                    this.isBillingFreq = false;
                    return item;
                  }
                  else {
                    this.checkBillingFrequency = false;
                    this.close();
                    this.commonService.implementToast('Some of these products are not available at the moment from Microsoft', 'Error');
                  }
                }
                return this.softwareSubscriptionPendingList = null;
              });
              this.softwareSubscriptionPendingList = res;
            }
            else {
              this.checkBillingFrequency = false;
              this.close();
              this.commonService.implementToast('These products are not available at the moment from Microsoft', 'Error');

            }

          },

          );
        this.checkBillingFrequency = true;
      }
      this.commonService.applyScrollFixedHeader(this.parentWrapper);
    },
      (error: any) => {
        console.info(error);
      });
  }
  //subscription



  getPendingSubscription(): void {
    this.manageService.currentPendingSubscriptions.pipe(takeUntil(this.ngUnsubscribe)).subscribe((model: AnnuityItemsViewModel[]) => {
      this.assignAndProccessPendingList(model);
    },
      (error: any) => {
        this.isBillingFreq = false;
        console.error(error);
        this.loadContent = true;
      });

  }

  private populateProductSupportedOptions(): void {
    this.subscriptionItemsPendingList.forEach((item) => {
      item.populateProductFamilyData(
        this.subscriptionItems,
        this.commonService,
        this.currencyPipe
      );
    });

    if (this.subscriptionItemsPendingList.length > 0) {
      this.totalPriceChange = this.pendingTotal = this.calculateTotalPriceChange();
    }
  }

  private assignAndProccessPendingList(list: AnnuityItemsViewModel[]): void {
    this.isBillingFreq = true;
    this.subscriptionItemsPendingList = [];
    let hasNCE = list.filter(x => x.chargeType == "NCE").length ? true : false;
    this.subscriptionItemsPendingList = list.map((sub) => {
      //this.loadContent=true;
      if (!sub?.qualification) {
        const qualification = this.manageService.subscriptionTypes?.find(i => i.value == sub?.stockGroup)?.text?.split(' - ')[1]
        sub.qualification = qualification
      }

      sub.editMPN = true;
      if (sub.chargeType == 'NCE') {

        sub.billingFrequency = '';
        sub.term = '';

        sub.editBillingFrequency = true;
        sub.editTerm = true;

        return sub;

      } else {
        return sub;
      }
    })
    this.customEndDateTypeFormArray = new FormArray(this.subscriptionItemsPendingList.map(() =>  new FormControl('Default')));
    this.customEndDatesFormArray = new FormArray(this.subscriptionItemsPendingList.map(() =>  new FormControl('')));
    if (hasNCE && list.length) {

      this.populateProductSupportedOptions();

      this.checkBillingFrequency = true;
    }
    this.commonService.applyScrollFixedHeader(this.parentWrapper);
  }

  calculateTotalPriceChange(): number {
    let totalPrice = 0;
    this.subscriptionItemsPendingList.forEach(subscription => {
      totalPrice += this.commonService.toNumber(subscription.quantity) * 
      (
        subscription.needToAdjustPrice()? 
          this.commonService.toNumber(subscription.itemPriceByBF.replace('$', '').replace(',', '')) :
          this.commonService.toNumber(subscription.itemPrice.replace('$', '').replace(',', ''))
      );
    });
    return totalPrice;
  }

  showAutoCompletePanel(trigger: any): void {
    trigger.openPanel();
  }


  displayFn(freq: string): string {
    return freq == '1' ? 'Monthly' : freq == 'T' ? 'Triennial' : 'Annual'
  }


  changeBillingFrequency(billingFrequency: string, sub: AnnuityItemsViewModel, index: number): void {
    const sku = `${sub.stockCode.split(':')[0]}:${sub.stockCode.split(':')[1]}:${sub.stockCode.split(':')[2]}`;
    const productOption = this.subscriptionItems.filter(x => `${x.stockCode.split(':')[0]}:${x.stockCode.split(':')[1]}:${x.stockCode.split(':')[2]}` == sku)

    let productToChange = productOption.find(x => x.stockCode.split(':')[3] == billingFrequency && x.stockCode.split(':')[0] == sub.term);
    if (!productToChange) {
      productToChange = productOption.find(x => (x.stockCode.split(':')[3] == billingFrequency));
    }
    if (productToChange) {
      productToChange.quantity = this.subscriptionItemsPendingList[index].quantity;
      const newList = [ ...this.subscriptionItemsPendingList ];
      newList[index] = productToChange
      this.assignAndProccessPendingList(newList);
    }
  }

  changeTerm(term: string, sub: AnnuityItemsViewModel, index: number): void {
    const thisStockCode = `${sub.stockCode.split(':')[1]}:${sub.stockCode.split(':')[2]}`;
    const productOption = this.subscriptionItems
      .filter(x => `${x.stockCode.split(':')[1]}:${x.stockCode.split(':')[2]}` == thisStockCode)

    let productToChange = productOption.find(x => (x.stockCode.split(':')[0] == term && x.stockCode.split(':')[3] == sub.billingFrequency));
    if (!productToChange) {
      productToChange = productOption.find(x => (x.stockCode.split(':')[0] == term));
    }
    if (productToChange) {
      productToChange.quantity = this.subscriptionItemsPendingList[index].quantity;
      const newList = [ ...this.subscriptionItemsPendingList ];
      newList[index] = productToChange
      this.assignAndProccessPendingList(newList);
    }
  }

  changeBillingFrequencyForSoftware(billingFrequency: string, sub: CSPPerpetualItemsViewModel) {
    sub.billingFrequency = billingFrequency;
  }

  toggleRowConfirmStatus(type: string, subscription: GetCSPSubscription, index: number, addonIndex: number): boolean {
    let pendingConfirmStatus = false;
    if (type === 'base') {
      if (subscription.out_qty === this.originalBaseQty[index] && subscription.out_activeSuspend === this.originalBaseActive[index] && subscription.originalDesc === subscription.out_sub_description && subscription.originalMpnId === subscription.editMpnIdValue) {
        pendingConfirmStatus = false;
      } else {
        pendingConfirmStatus = true;
      }
    } else if (type === 'addon') {
      if (subscription.out_qty === this.originalAddonQty.filter(x => x.baseIndex === index)[addonIndex].qty && subscription.out_activeSuspend === this.originalAddonActive.filter(x => x.baseIndex === index)[addonIndex].activeSuspend && subscription.originalDesc === subscription.out_sub_description && subscription.originalMpnId === subscription.editMpnIdValue) {
        pendingConfirmStatus = false;
      } else {
        pendingConfirmStatus = true;
      }
    }

    if (pendingConfirmStatus && subscription) {
      $(`#${subscription.out_subscription_id} .statustext`).html('<span class=\'pending-pronto-confirmation\' style=\'font-weight: bold\'>Pending Confirm</span>');
    } else if (!pendingConfirmStatus && subscription) {
      $(`#${subscription.out_subscription_id} .pending-pronto-confirmation`).remove();
      $(`#${subscription.out_subscription_id} .statustext`).html(`${subscription.out_status_desc}`);
    }

    if (this.subscriptionItemsPendingList.length || this.subscriptionItemsPendingList.length) {
      pendingConfirmStatus = true;
    }

    return pendingConfirmStatus;
  }

  removeSubscriptionPendingItem(index: number): void {
    this.subscriptionItemsPendingList.splice(index, 1);
    this.manageService.monitorPendingSubscriptions(this.subscriptionItemsPendingList);
  }

  confirmSubscription(): void {
    //this.isBillingFreq=true;
    for (let i = 0; i < this.subscriptionItemsPendingList.length; i++) {
      //check mpnId is not empty for all pendingSubscritions
      if (!this.subscriptionItemsPendingList[i].mpn) {
        this.commonService.implementToast('MPN is mandatory', 'Error');
        return;
      }

      // check empty billing frequency
      if (!this.subscriptionItemsPendingList[i].billingFrequency) {
        this.commonService.implementToast('Please select billing frequency', 'Error');
        return;
      }
    }

    let flag = false;

    if (this.subscriptionItemsPendingList.length) {
      this.subscriptionItemsPendingList.forEach(item => {
        if (item.stockGroup === '85CU') {
          if (!item.ownerEmailStatus) {
            this.commonService.implementToast('Please provide valid existing user email or external domain user email', 'Error');
            flag = true;
          }
        }
      });
    }
    if (!flag) {
      let hasNceAddon = false;
      this.confirmSubscriptions = [];
      this.subscriptionItemsPendingList.forEach((annuityItem, i) => {
        if (hasNceAddon == false) {
          if (annuityItem.isAddon == true) {
            hasNceAddon = true;
          }
        }
        this.confirmAnnuityItemSubscription = {} as CSPModifySubscriptionViewModel;

        this.confirmAnnuityItemSubscription = {
          tenantId: this.tenantId,
          mpnId: this.commonService.parseNPM(annuityItem.mpn),
          subscriptionId: '',
          subscriptionDescription: annuityItem.subscriptionDescription,
          customerReference: this.poReference,
          stockDescription: annuityItem.description,
          parentSubscriptionId: '',
          stockCode: annuityItem.stockCode,
          qty: annuityItem.quantity,
          status: '',
          ownerEmail: annuityItem.ownerEmail,
          price: annuityItem.itemPrice,
          totalPrice: annuityItem.totalPrice.toString(),
          billingFrequency: this.commonService.CSPBFMapping(annuityItem.billingFrequency),
          stockGroup: annuityItem.stockGroup,
          offerId: annuityItem.offerId,
          chargeType: annuityItem.chargeType,
          qualification: annuityItem?.qualification
        };

        //custom end date
        if (!this.commonService.isEmpty(this.getCustomEndDateControlByIndex(i).value)) {
          const customEndDate = new Date(
            this.getCustomEndDateControlByIndex(i).value.year,
            this.getCustomEndDateControlByIndex(i).value.month - 1,
            this.getCustomEndDateControlByIndex(i).value.day
          )
          this.confirmAnnuityItemSubscription.customTermEndDate = this.datePipe.transform(customEndDate, 'yyyy-MM-dd') + ' 23:59:00'
        } else {
          this.confirmAnnuityItemSubscription.customTermEndDate = null;
        }

        if (this.confirmAnnuityItemSubscription.tenantId) {
          this.confirmSubscriptions.push(this.confirmAnnuityItemSubscription);
        }
      });


      if (this.confirmSubscriptions.length) {
        const tempMPNIdArray = [];
        this.confirmSubscriptions.map(item => {
          if (item.mpnId && item.mpnId !== '' && item.mpnId != this.NoMPNText && tempMPNIdArray.indexOf(item.mpnId) === -1) {
            tempMPNIdArray.push(item.mpnId); // get unique mpnId
          }
        });

        if (tempMPNIdArray.length) {
          this.validateMpnId(tempMPNIdArray, this.confirmSubscriptions, hasNceAddon);
        } else {

          this.openConfirmPendingModal(hasNceAddon);
        }
      } else {
        this.commonService.implementToast('There is no pending subscription to confirm', 'Error');
      }
    }
  }

  enablePendingAddonEditMpn(pendingAddOn: AnnuityItemsViewModel): void {
    pendingAddOn.editMPN = true;
  }

  onPendingMPNIdChang(addonItemPending: AnnuityItemsViewModel): void {
    if (!addonItemPending.mpn) {
      this.commonService.implementToast('MPN is mandatory', 'Error');
    }
  }

  validateMpnId(mpnIDs: string[], items: CSPModifySubscriptionViewModel[], hasNceAddon: boolean = false) {

    this.checkMpnId = false;
    this.showMpnIdloading = true;
    let validFlag = true;
    const errorIdArray = [];

    items.forEach(item => {
      if (item.stockGroup === '85CU') {
        // checks to exclude if already have 17G
        this.isToCheckOwnerEmail = true;
        const pendingAzurePlan = this.subscriptionItemsPendingList.find(x => x.stockCode === 'DZH318Z0BPS6:0001' && x.mpn === item.mpnId);
        if (pendingAzurePlan) {
          this.commonService.implementToast('Only one Azure Plan is allowed per tenant with same partner Id', 'Error');
          this.showMpnIdloading = false;
          return;
        }
        // checks to exclude if already have traditional azure sku
      }
    });

    this.commonService.implementToast('Verifying MPN ID ...', 'Info');

    mpnIDs.forEach((mpnId, index) => {
      this.manageService.GetPartnerByMPNId(mpnId).subscribe((res: MnpIdAipiResponse) => {
        // this.checkMpnId = false;
        if (res.result === 'Success') {
          this.commonService.implementToast('Verifying Microsoft Partner Agreement Status ...', 'Info');
          this.manageService.GetMPAStatusByMPNId(mpnId).subscribe((result: MnpIdAipiResponse) => {
            this.checkMpnId = true;
            if (result.status === false) {
              // this.checkMpnId = result.status;
              this.commonService.implementToast('Please check Microsoft Partner Agreement status with partner_id ' + mpnId, 'Error', true);
              this.commonService.showValidator('#' + mpnId, 'Please check MPA status with MPN ID: ' + mpnId, 'right', 'error');
              this.showMpnIdloading = false;
              validFlag = false;
            } else {
              // this.checkMpnId = result.status;
              this.showMpnIdloading = false;

              if (validFlag && (index === mpnIDs.length - 1)) {  // check the last MPN ID then update subscriptions
                this.openConfirmPendingModal(hasNceAddon);
              }
            }

          });
        } else {
          this.checkMpnId = true;
          this.showMpnIdloading = false;
          this.loadContent = true;
          validFlag = false;
          errorIdArray.push(mpnId);
          this.commonService.implementToast(res.info, 'Error', true);

          if (errorIdArray.length > 0 && (index === mpnIDs.length - 1)) {
            setTimeout(() => {
              errorIdArray.forEach(id => {
                this.commonService.showValidator('#' + id, 'Invalid MPN ID: ' + id, 'right', 'error');
              });
            }, 1500);
          }
        }

      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        }
      );
    });

  }

  openConfirmPendingModal(hasNCEAddon: boolean = false): void {

    const dialogRef = this.dialog.open(ConfirmSubscriptionComponent, {
      width: '650px',
      data: {
        totalPriceChange: this.totalPriceChange,
        pendingTotal: this.pendingTotal,
        asNCEAddon: hasNCEAddon,
        hasTrial: this.subscriptionItemsPendingList.some(x => x.chargeType == 'TRIAL')
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.poReference = result;
        this.loadContent = false;

        // this.commonService.createCookie('ChangeSubscriptionAmount', this.changeSubscriptionAmount.toString(), 1);
        // this.changeSubscriptionAmount = toNumber(this.commonService.readCookie('ChangeSubscriptionAmount'));

        if (this.confirmSubscriptions.length) {

          this.confirmSubscriptions.map(item => {
            item.customerReference = this.poReference;
          });

          this.createOrUpdateCSPSubscriptions();

        }
      }
    });
  }

  createOrUpdateCSPSubscriptions(): void {

    this.manageService.createOrUpdateCSPSubscription(this.confirmSubscriptions).subscribe((res: CSPModifySubscriptionResponse[]) => {
      if (res.length) {
        this.finishSubscriptions = res;
        this.loadContent = true;
        const dialogRefFinish = this.dialog.open(FinishSubscriptionComponent, {
          width: '650px',
          data: { finishSubscriptions: this.finishSubscriptions },
          disableClose: true
        });

        dialogRefFinish.afterClosed().subscribe(() => {
          this.subscriptionItemsPendingList = [];
          this.azureSubscriptionItemsPendingList = [];
          this.totalPriceChange = 0;
          this.pendingTotal = 0;
          this.subscriptionItemsPendingList = [];
          this.manageService.monitorPendingSubscriptions([]);
          // this.manageService.monitorPendingAzureSubscriptions([]);
          this.manageService.monitorSubscriptionConfirmValue('Update');
          this.manageService.backToTenentPage(this.tenantId);
        });
      }
    });
  }


  // software
  removeSoftwareSubscriptionPendingList(index: number): void {
    const temp = [ ...this.softwareSubscriptionPendingList ]
    temp.splice(index, 1);
    this.manageService.monitorPendingSoftware(temp);
  }

  confirmSoftwareSubscription(): void {
    //prevent confirming when checking MPN
    if (this.isConfirmingSoftwareMpnID) {
      return;
    }
    //check mpnId is not empty for all pendingSubscritions
    if (!this.softwareMpnIdSelect) {
      this.commonService.implementToast('MPN is mandatory', 'Error');
      return;
    }

    // check empty billing frequency
    for (let i = 0; i < this.softwareSubscriptionPendingList.length; i++) {
      if (!this.softwareSubscriptionPendingList[i].billingFrequency) {
        this.commonService.implementToast('Please select billing frequency', 'Error');
        return;
      }
    }


    this.totalSoftwareSubscriptionPendingPrice = 0;

    this.softwareSubscriptionPendingList.forEach(softwareSubscription => {
      if (softwareSubscription.isMonthly) {
        softwareSubscription.totalPrice = this.commonService.toNumber(softwareSubscription.monthlyPrice) * this.commonService.toNumber(softwareSubscription.quantity);
      } else {
        softwareSubscription.totalPrice = this.commonService.toNumber(softwareSubscription.itemPrice.replace('$', '').replace(',', '')) * this.commonService.toNumber(softwareSubscription.quantity);
      }

      this.totalSoftwareSubscriptionPendingPrice += softwareSubscription.totalPrice;
    });


    const dialogRef = this.dialog.open(ConfirmSoftwareComponent, {
      width: '650px',
      data: {
        totalSoftwareSubscriptionPendingPrice: this.totalSoftwareSubscriptionPendingPrice
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.continueSaveSoftwareSubscriptionList = [];
        this.loadContent = false;
        if (this.softwareSubscriptionPendingList.length) {
          this.softwareSubscriptionPendingList.forEach(item => {
            this.continueSaveSoftwareSubscriptionItem = {} as CSPPerpetualModifyViewModel;
            this.continueSaveSoftwareSubscriptionItem = {
              tenantId: this.tenantId,
              tenantName: this.details.customer.out_company_name,
              lineType: item.lineType,
              customerReference: result,
              unitPrice: item.itemPrice,
              lineTotal: item.totalPrice.toString(),
              stockCode: item.stockCode,
              description: item.description,
              skuId: item.skuId,
              billingFrequency: item.billingFrequency,
              productId: item.productId,
              catalogItemId: item.catalogItemId,
              qty: item.quantity,
              status: 'PS',
              // mpnId: item.mpnId,
              mpnId: this.commonService.parseNPM(this.softwareMpnIdSelect),
              lineSeq: '',
              isUpdateSuccessful: true,
              isMonthly: item.isMonthly,
              orderNumber: '',
              message: '',
              subscriptionId: '',
              qualification: item.qualification,
              scope: item.scope
            };
            this.continueSaveSoftwareSubscriptionList.push(this.continueSaveSoftwareSubscriptionItem);
          });

          this.manageService.CreatePerpetualOrder(this.continueSaveSoftwareSubscriptionList).subscribe((res: PerpetualApiResponse) => {
            this.softwareSubscriptionApiResponse = res;
            this.loadContent = true;
            // tslint:disable-next-line:no-shadowed-variable
            const dialogRef = this.dialog.open(FinishSoftwareComponent, {
              width: '650px',
              data: { softwareSubscriptionApiResponse: this.softwareSubscriptionApiResponse }
            });

            dialogRef.afterClosed().subscribe(() => {

              this.softwareSubscriptionPendingList = [];

              this.manageService.monitorPendingSoftware([]);

              this.manageService.monitorSoftwareConfirmValue('Update');

            });
          },
            () => {
              const softwareApiResponse = {
                status: 'Fail',
                message: 'Fail to purchase software'
              };
              this.loadContent = true;
              // tslint:disable-next-line:no-shadowed-variable
              const dialogRef = this.dialog.open(FinishSoftwareComponent, {
                width: '650px',
                data: { softwareSubscriptionApiResponse: softwareApiResponse }
              });

              dialogRef.afterClosed().subscribe(() => {
                this.softwareSubscriptionPendingList = [];
                this.manageService.monitorPendingSoftware([]);
              });
            });
        }
      }
    });
  }

  assignEndDate(date: string, pendingItemSKU: string): void {
    let term = pendingItemSKU.split(':')[0];
    let dateToChange = this.commonService.getValueFromDDDate(date);

    const today = new Date();
    const selectedDate = new Date(dateToChange.year, dateToChange.month - 1, dateToChange.day);
    let daysDiff = Math.round((selectedDate.valueOf() - today.valueOf()) / (1000 * 60 * 60 * 24));
    
    if (daysDiff > 30 && term == "P1M") {
      let oneMonthAlignDate = new Date(today.getFullYear(), today.getMonth(), dateToChange.day);
      daysDiff = Math.round((oneMonthAlignDate.valueOf() - today.valueOf()) / (1000 * 60 * 60 * 24));

      if (daysDiff <= 0) {
        oneMonthAlignDate = new Date(today.getFullYear(), today.getMonth() + 1, dateToChange.day);
      }
      dateToChange = { day: oneMonthAlignDate.getDate(), month: oneMonthAlignDate.getMonth() + 1, year: oneMonthAlignDate.getFullYear() };
    }

    this.getCustomEndDateControlByIndex(this.setSideNavIndex).setValue(dateToChange);
    this.commonService.implementToast('Expiry date applied!', 'Success');
    this.sidenavService.panel.close()
  }

  openRightPanel(tempRef: any, index) {
    if (this.getCustomEndDateTypeControlByIndex(index).value == 'Co-Term') {
      if (this.sidenavService?.panel?.opened) {
        this.sidenavService.panel.close()
      } else {
        this.setSideNavIndex = index;
        this.sidenavService.setViewContainerRef(this.vcr);
        this.sidenavService.setPanelContent(tempRef);
        this.sidenavService.open();
      }
    }
  }

  public getCustomEndDateTypeControlByIndex(index: number): FormControl {
    return this.customEndDateTypeFormArray.at(index) as FormControl;
  }

  public getCustomEndDateControlByIndex(index: number): FormControl {
    return this.customEndDatesFormArray.at(index) as FormControl;
  }

  public isEveryCustomDateValid(): boolean {
    return this.subscriptionItemsPendingList?.every((s,i) => (this.getCustomEndDateTypeControlByIndex(i)?.value != 'Co-Term' || !this.commonService.isEmpty(this.getCustomEndDateControlByIndex(i)?.value)))
  }

  downloadExcelSubConfirmProducts() {
    this.confirmSubscriptions = [];
    this.subscriptionItemsPendingList.forEach(annuityItem => {
      const haveExiting = this.subscriptionItemsPendingList.find(s => s.stockCode == annuityItem.stockCode)
      this.confirmAnnuityItemSubscription = {} as CSPModifySubscriptionViewModel;
      this.currentLineItemsId += 1;
      this.confirmAnnuityItemSubscription = {
        tenantId: this.tenantId,
        mpnId: this.commonService.parseNPM(annuityItem.mpn),
        subscriptionId: '',
        subscriptionDescription: annuityItem.subscriptionDescription,
        customerReference: this.poReference,
        stockDescription: annuityItem.description,
        parentSubscriptionId: '',
        stockCode: annuityItem.stockCode,
        qty: annuityItem.quantity,
        status: '',
        ownerEmail: annuityItem.ownerEmail,
        //price: annuityItem.itemPrice,
        price: annuityItem.itemPrice,
        unitPriceByBF: annuityItem.itemPriceByBF,
        unitPriceByBFUnit: annuityItem.itemPriceByBFUnit,
        UnitCost_RRP : annuityItem.itemRRPrice,
        totalPrice: annuityItem.totalPrice.toString(),
        billingFrequency: annuityItem.billingFrequency,
        stockGroup: annuityItem.stockGroup,
        offerId: annuityItem.offerId,
        chargeType: annuityItem.chargeType,
        qualification: annuityItem?.qualification
      };
      if (this.confirmAnnuityItemSubscription.tenantId) {
        this.confirmSubscriptions.push(this.confirmAnnuityItemSubscription);
      }
    });
    this.manageService.downloadExcelSubConfirmProducts(this.confirmSubscriptions).subscribe((res: any) => {
      const fileName = `CSP_QUOTE_`+ this.accountId;
      this.fileService.saveAsExcelFile(res, fileName);
      this.ngProgress.done();
      this.commonService.implementToast('Report downloaded successfully', 'Success');
    });

  }
  downloadExcelSoftwareConfirmProducts() {
    this.continueSaveSoftwareSubscriptionList = [];
    this.softwareSubscriptionPendingList.forEach(item => {
      //const haveExiting = this.softwareSubscriptionPendingList.find(s => s.stockCode == item.stockCode)  
      this.continueSaveSoftwareSubscriptionItem = {} as CSPPerpetualModifyViewModel;
      this.currentLineItemsId += 1;
      this.continueSaveSoftwareSubscriptionItem = {
        tenantId: this.tenantId,
        tenantName: this.details.customer.out_company_name,
        lineType: item.lineType,
        customerReference: item.programType,
        //unitPrice: item.itemPrice,
        unitPrice: item.itemPrice,
        unitPriceByBF: item.itemPriceByBF,
        unitPriceByBFUnit: item.itemPriceByBFUnit, 
        lineTotal: item.totalPrice.toString(),
        stockCode: item.stockCode,
        description: item.description,
        skuId: item.skuId,
        billingFrequency: item.billingFrequency,
        productId: item.productId,
        catalogItemId: item.catalogItemId,
        qty: item.quantity,
        status: 'PS',
        // mpnId: item.mpnId,
        mpnId: this.commonService.parseNPM(this.softwareMpnIdSelect),
        lineSeq: '',
        isUpdateSuccessful: true,
        isMonthly: item.isMonthly,
        orderNumber: '',
        message: '',
        subscriptionId: '',
        qualification: item.qualification
      };
      if (this.continueSaveSoftwareSubscriptionItem.tenantId) {
        this.continueSaveSoftwareSubscriptionList.push(this.continueSaveSoftwareSubscriptionItem);
      }
    });
    this.manageService.downloadExcelSoftwareConfirmProducts(this.continueSaveSoftwareSubscriptionList).subscribe((res: any) => {
      const fileName = `CSP_QUOTE_`+ this.accountId;
      this.fileService.saveAsExcelFile(res, fileName);
      this.ngProgress.done();
      this.commonService.implementToast('Report downloaded successfully', 'Success');
    });

  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  changeQty(annuityItem: AnnuityItemsViewModel): void {

    if (!annuityItem.quantity) {
      annuityItem.quantity = '1';
    } else {
      if (annuityItem.minQty) {
        if (this.commonService.toInteger(annuityItem.quantity) < this.commonService.toInteger(annuityItem.minQty.replace(',', ''))) {
          this.commonService.implementToast(`the min qty is ${annuityItem.minQty}`, "Info");
          annuityItem.quantity = this.commonService.toInteger(annuityItem.minQty.replace(',', '')).toString();
        }
      }
      if (annuityItem.maxQty) {
        if (this.commonService.toInteger(annuityItem.quantity) > this.commonService.toInteger(annuityItem.maxQty.replace(',', ''))) {
          this.commonService.implementToast(`the max qty is ${annuityItem.maxQty}`, "Info");
          annuityItem.quantity = this.commonService.toInteger(annuityItem.maxQty.replace(',', '')).toString();
        }
      }
    }

    this.populateProductSupportedOptions();
  }

  ngOnDestroy() {
    if (this.sidenavService?.panel?.opened) {
      this.sidenavService.panel.close()
    }
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
